export enum ApplicationNames {
  skillbox = 'skillbox',
  lerna = 'lerna',
  geekbrains = 'geekbrains',
}
